import Immutable from 'immutable';
import _ from 'underscore';

import { translate } from 'sharedreact/utils/LanguageSupport';

const Content: {
  id: string,
  ink: string | null,
  book: string | null,
  type: string | null,
  ruling: number,
  angle: number,
  dotShape: string | null,
  printingMethod: string | null,
  printingUnit: number,
  r: number,
  g: number,
  b: number,
  opacity: number
} = {
  id: '',
  ink: null,
  book: null,
  type: null,
  ruling: -1,
  angle: -1,
  dotShape: null,
  printingMethod: null,
  printingUnit: -1,
  r: -1,
  g: -1,
  b: -1,
  opacity: 0
};

function addIdIfMissing (values: Partial<typeof Content>): Partial<typeof Content> {
  if (Immutable.isImmutable(values)) {
    if (!values.has('id')) {
      const entries = values.toJS();
      const newValues = {...entries, id: _.uniqueId() };
      return newValues;
    }
  } else {
    if (values.id == null) {
      return {...values, id: _.uniqueId() };
    }
  }

  return values;
}

class FileInfoInk extends Immutable.Record(Content) {
  constructor (values: Partial<typeof Content>) {
    super(addIdIfMissing(values));
  }

  get inkName (): string | null {
    switch (this.ink && this.ink.toLowerCase()) {
      case 'cyan':
      case 'c': {
        return translate('shared.fileinfo.inkname.cyan');
      }
      case 'magenta':
      case 'm': {
        return translate('shared.fileinfo.inkname.magenta');
      }
      case 'yellow':
      case 'y': {
        return translate('shared.fileinfo.inkname.yellow');
      }
      case 'black':
      case 'k': {
        return translate('shared.fileinfo.inkname.black');
      }
      case 'pantone': {
        return translate('shared.fileinfo.inkname.pantone');
      }
      default: {
        return this.ink;
      }
    }
  }
  get typeName (): string | null {
    switch (this.type && this.type.toLowerCase()) {
      case 'normal': {
        return translate('shared.fileinfo.inktype.normal');
      }
      case 'transparent': {
        return translate('shared.fileinfo.inktype.transparent');
      }
      case 'opaque': {
        return translate('shared.fileinfo.inktype.opaque');
      }
      case 'background': {
        return translate('shared.fileinfo.inktype.background');
      }
      case 'knife': {
        return translate('shared.fileinfo.inktype.knife');
      }
      case 'none': {
        return translate('shared.fileinfo.inktype.none');
      }
      default: {
        return this.type;
      }
    }
  }
  get PDFtypeName (): string | null {
    switch (this.type && this.type.toLowerCase()) {
      case 'normal': {
        return translate('shared.fileinfo.inktype.normal');
      }
      case 'transparent': {
        return translate('shared.fileinfo.inktype.transparent');
      }
      case 'opaque': {
        return translate('shared.fileinfo.inktype.opaque');
      }
      case 'none': {
        return translate('shared.fileinfo.inktype.none');
      }
      case 'knife' :
      case 'background' :
        {
          if ( this.opacity > 0.95) {
            return translate('shared.fileinfo.inktype.opaque');
          } else {
            return translate('shared.fileinfo.inktype.normal');
          }
        }
       default: {
        return this.type;
      }
    } 
  } 
  get printingMethodName (): string | null {
    switch (this.printingMethod && this.printingMethod.toLowerCase()) {
      case 'offset': {
        return translate('shared.fileinfo.printingmethod.offset');
      }
      case 'gravure': {
        return translate('shared.fileinfo.printingmethod.gravure');
      }
      case 'flexo': {
        return translate('shared.fileinfo.printingmethod.flexo');
      }
      case 'letterpress': {
        return translate('shared.fileinfo.printingmethod.letterpress');
      }
      case 'screen': {
        return translate('shared.fileinfo.printingmethod.screen');
      }
      case 'inkjet': {
        return translate('shared.fileinfo.printingmethod.inkjet');
      }
      case 'toner': {
        return translate('shared.fileinfo.printingmethod.toner');
      }
      case 'thermaltransfer': {
        return translate('shared.fileinfo.printingmethod.thermaltransfer');
      }
      case 'other': {
        return translate('shared.fileinfo.printingmethod.other');
      }
      case 'unknown': {
        return translate('shared.fileinfo.printingmethod.unknown');
      }
      default: {
        return this.printingMethod;
      }
    }
  }
  get printingUnitValue (): string {
    if (this.printingUnit >= 0) {
      return (this.printingUnit + 1).toString();
    }
    return '';
  }
}

export default FileInfoInk;
